module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sky-input-file"
  }, [_c('div', {
    ref: "previewFileLabel",
    staticClass: "files untouched",
    domProps: {
      "textContent": _vm._s(_vm.previewFileLabel)
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.changePreviewFiles
    }
  }), _vm._v(" "), _c('button', {
    domProps: {
      "textContent": _vm._s(_vm.buttonName)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/template-compiler.js?{"id":"data-v-8c7e227c"}!./scripts/sky-input-file/SkyInputFile.html
// module id = 381
// module chunks = 1